// 3rd party imports
import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject } from 'mobx-react';
import { LocalizedComponentProps, LocalizedText, withLocalization } from '@shared-ui/localization-context';

// bernie
import { ContextStore, AnalyticsStore } from 'bernie-core';

// ui
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading, UitkSubheading, UitkText } from 'uitk-react-text';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkList, UitkListItem } from 'uitk-react-list';
import { UitkFigure, UitkImage } from 'uitk-react-images';
import { UitkLink } from 'uitk-react-link';

// util
import { modifyLocaleParam } from '../util/LocaleParamTransformer';

export interface ErrorPageProps extends LocalizedComponentProps {
  context?: ContextStore;
  analytics?: AnalyticsStore;
}

@withLocalization
@inject('context', 'analytics')
export class ErrorPage extends React.Component<ErrorPageProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    if (typeof window !== 'undefined') {
      // tslint:disable-next-line:no-console
      console.log('Tried to hit: ' + window.location);
    }

    const { analytics } = this.props;
    const referrerId = 'hub.error.page';

    return (
      <UitkSpacing className="container" padding={{ block: 'twelve' }}>
        <UitkLayoutGrid columns={12} space="three">
          <UitkLayoutGridItem colSpan={7}>
            <UitkLayoutFlex space="four" direction="column">
              <UitkHeading tag="h1" size={2}>
                Oops!
              </UitkHeading>
              <UitkText size={700}>We can't seem to find the page you're looking for.</UitkText>
              <UitkText size={400} weight="bold">
                Error Code: 404
              </UitkText>
              <UitkSpacing padding={{ inlinestart: 'one' }}>
                <div>
                  <UitkSubheading>Here are some helpful links instead:</UitkSubheading>
                  <UitkSpacing margin="one">
                    <UitkList bullet="no-bullet">
                      <UitkListItem key="">
                        <UitkLink
                          analytics={analytics.setupTracker(referrerId, 'Affiliate Home', true)}
                        >
                          <Link
                            to={['', modifyLocaleParam(this.props.context.locale), 'home'].join('/')}
                          >
                            <LocalizedText message="custom.header.home" />
                          </Link>
                        </UitkLink>
                      </UitkListItem>
                      <UitkListItem key="">
                        <UitkLink
                          analytics={analytics.setupTracker(referrerId, 'Affiliate SignIn', true)}
                        >
                          <Link
                            to={['', modifyLocaleParam(this.props.context.locale), 'signin'].join('/')}
                          >
                            <LocalizedText message="custom.header.sign.in" />
                          </Link>
                        </UitkLink>
                      </UitkListItem>
                      <UitkListItem key="">
                        <UitkLink
                          analytics={analytics.setupTracker(referrerId, 'Affiliate Sign Up', true)}
                        >
                          <Link
                            to={['', modifyLocaleParam(this.props.context.locale), 'signup'].join('/')}
                          >
                            <LocalizedText message="lp.join.action.text" />
                          </Link>
                        </UitkLink>
                      </UitkListItem>
                    </UitkList>
                  </UitkSpacing>
                </div>
              </UitkSpacing>
            </UitkLayoutFlex>
          </UitkLayoutGridItem>
          <UitkLayoutGridItem colSpan={5}>
            <div style={{ height: '360px' }}>
              <UitkFigure className="all-image-fit-contain">
                <UitkImage alt="Expedia Group Affiliate Program" src="../../images/questions_guide.png" />
              </UitkFigure>
            </div>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
      </UitkSpacing>
    );
  }
}
